<p-dialog
  #dialog
  [className]="'eccc'"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '1200px'}"
  [minY]="100"
  [maximizable]="false"
  [autoZIndex]="false"
  [closable]="false"
  (onShow)="scrollToTop()"
  [header] = "'CREDIT_ADJUSTMENT_REPORT.reportStep.addDetailsTitle' | translate">

  <form [formGroup]="currentStepObj.ccrForm">
    <formly-form [form]="currentStepObj.ccrForm" [model]="currentStepObj.ccrModel" [fields]="currentStepObj.commonFields"></formly-form>
  </form>
  <p *ngIf="this.currentStepObj.ccrModel?.facility?.type !== 'PROVINCE'">{{ 'CREDIT_ADJUSTMENT_REPORT.reportStep.facilityDetails' | translate }}: <a class="link" href="#" (click)="viewFacilityDetails($event)">{{ 'COMMON.actionsLabel.VIEW' | translate }}</a></p>

  <div class="row">
    <div class="col-6" #leftCol>
      <form [formGroup]="currentStepObj.ccrForm">
        <formly-form [form]="currentStepObj.ccrForm" [model]="currentStepObj.ccrModel" [fields]="currentStepObj.ccrFields"></formly-form>
      </form>
    </div>
    <div class="col-6 border-left" #rightCol>
      <form [formGroup]="currentStepObj.form">
        <formly-form [form]="currentStepObj.form" [model]="currentStepObj.model" [fields]="currentStepObj.fields"></formly-form>
      </form>
    </div>
  </div>

  <div class="row border-bottom flex-grow-0">
    <div class="col-12">
      <h3 class="m-0 mt-4 pb-2"> {{'CREDIT_ADJUSTMENT_REPORT.reportStep.additionalDetails' | translate}} </h3>
    </div>
  </div>
  <form [formGroup]="currentStepObj.form">
    <formly-form [form]="currentStepObj.form" [model]="currentStepObj.model" [fields]="currentStepObj.additionalDetailsFields"></formly-form>
  </form>

  <formly-form [form]="form" [model]="model" [fields]="needMoreInfoFields"></formly-form>

  <div class="row" *ngIf="currentStepObj.detailSectionDocumentUploadConfig && taskList.length">
    <div class="col-12">
      <div class="tools-selector">
        <ng-select
          wcag-label
          [placeholder]="'CREDIT_ADJUSTMENT_REPORT.reportStep.downloadTemplate' | translate"
          [inputAttrs]="{'aria-label': 'COMMON.actionsLabel.tools' | translate}"
          [items]="taskList"
          bindLabel="name"
          bindValue="id"
          class="ng-dropdown-left"
          [(ngModel)]="downloadSelected"
          [appendTo]="body"
          (change)="downloadTemplate($event)">
        </ng-select>
      </div>
    </div>
  </div>

  <div *ngIf="currentStepObj.detailSectionDocumentUploadConfig" class="form-group mt-4">
    <ng-container *ngIf = "currentStepObj.documentUploadLabelConfig">
      <div class="row mb-3 p-1">
        <div class="col-12">
          {{currentStepObj.documentUploadLabelConfig.label | translate}}
          <fa-icon
          *ngIf="currentStepObj.documentUploadLabelConfig.tooltip"
          pTooltip="{{currentStepObj.documentUploadLabelConfig.tooltip | translate}}"
          tooltipPosition="top"
          [escape]="false"
          [icon]="['fas', 'info-circle']">
        </fa-icon>
        </div>
      </div>
    </ng-container>
    <app-documents
      [documentUploadConfig]="currentStepObj.detailSectionDocumentUploadConfig"
      (documentResult)="documentUploadHandler($event)"
      [disabled]="documentUploadDisabled"
      [showPlaceholders]="true">
    </app-documents>
  </div>

  <div class="d-flex justify-content-end mt-2">
    <button type="button" disableOnUpload class="btn btn-secondary mr-2" (click)="close()">{{'CREDIT_CREATION_REPORT.reportStep.close' | translate}}</button>
    <button type="button"
            disableOnUpload
            class="btn btn-primary"
            (click)="save()">
      {{'CREDIT_CREATION_REPORT.reportStep.save' | translate}}
    </button>
  </div>
</p-dialog>
